import {HlsController} from "./controllers/ms-hls";

import React from "react";
import {injectIntl} from "react-intl";
import Clappr from '@clappr/player';
import LevelSelector from "level-selector";
import {VideoStateMgr} from "./controllers/ms-state-controller";

//import {ViewersHoverPlugin} from "./plugins/toppanel/top-panel";

class ClapprPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      errorId: ""
    }
    this.player = null;
    this.hlsController = new HlsController();
    this.parentElement = React.createRef();

    this.change = this.change.bind(this);
    this.getClapprOpt = this.getClapprOpt.bind(this);
    this.stateMgr = VideoStateMgr.createManager(
      this.props.autoplay,
      this.props.restMS,
      (errorId, streamState)  => {
        console.log('----------> setErrorScreen');
        this.props.setErrorScreen(errorId, streamState);
      },
      (errorId, streamState) => {
        console.log('----------> startPlayer');
        this.props.startPlayer(errorId, streamState);
      });
  }

  componentDidMount() {
    this.change(this.props.source);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.source !== this.props.source) {
      this.change(this.props.source);
    }
  }

  componentWillUnmount() {
    this.stateMgr.dispose();
    this.destroyPlayer();
  }

  destroyPlayer() {
    if (this.player) {
      this.player.destroy();
    }
    this.player = null;
  }

  change(source) {
    if (this.player) {
      this.destroyPlayer();
    }
    let self = this;
    let cOpt = this.getClapprOpt(source, () =>{
      console.log('HERE!!!!');
    });
    cOpt['mute'] = this.props.autoplay == 'MUTEONLY';
    this.player = new Clappr.Player(cOpt);
    this.player.on(Clappr.Events.PLAYBACK_ERROR, function(error){console.log(error);});

    this.stateMgr.setPlayer(this.player, true);
  }

  getClapprOpt(source, readFnc) {


    return {
      disableErrorScreen: true,
      autoPlay: true, // autoplay always true
      source:source,
      parent: this.parentElement.current,
      width: '100%',
      height: '100%',
      plugins: [LevelSelector, Clappr.HLS],
      levelSelectorConfig: {
        title: 'Quality',
        labels: {
          4: '1080p',
          3: '720p',
          2: '360p',
          1: '240p',
          0: '160p',
        },
        labelCallback: (playbackLevel, customLabel) => { // display resolution level text as {Height}p
          return (playbackLevel.level.height)? playbackLevel.level.height + 'p' : customLabel;
        },
      },
      hlsjsConfig: this.hlsController.getConfig(),
      events: {
        onReady: readFnc,
        onError: function(e) {
          console.log(e);
        }
      }
    }
  }

  render() {
    return(
      <div ref={this.parentElement} className="player-wrapper"></div>
    )
  }
}
export default injectIntl(ClapprPlayer);
